/**
 * @description: 会员充值报表
 * @author: hwx
 * @update: lyr
*/
<template>
    <div class="mr-hcz-report">
        <div class="member-cz-list">
            <div class="row row-margin">
                <label class="list-label-2">时间:</label>
                <div class="col-md-3 list-time">
                    <div ref="time">
                        <input type="text" class="form-control laydate-icon" v-model="startTime" /> -
                        <input type="text" class="form-control laydate-icon" v-model="endTime" />
                    </div>
                </div>
                <div class="col-md-1 ct-col jh-tit-sel">
                    <select class="form-control" ref="cz_tit_sel">
                        <option value="1">收款门店</option>
                        <option value="2">注册门店</option>
                    </select>
                </div>
                <div class="col-md-2 jh-con-val">
                    <div class="ct-col" v-show="cz_field == '1'">
                        <select class="form-control" ref="cz_shop"></select>
                    </div>
                    <div class="ct-col" v-show="cz_field == '2'">
                        <select class="form-control" ref="cz_reg_shop"></select>
                    </div>
                </div>
                <label class="list-label-4">支付状态:</label>
                <div class="col-md-2 ct-col">
                    <select class="form-control" data-placeholder="请选择" ref="paymentstatus">
                        <option value="100">全部</option>
                        <option value="-1">待支付</option>
                        <option value="1">已付款</option>
                        <option value="4">已作废</option>
                    </select>
                </div>
                <label class="list-label-4">支付类型:</label>
                <div class="col-md-2 ct-col">
                    <select class="form-control" data-placeholder="请选择" ref="paymenttype"></select>
                </div>
            </div>
            <div class="row row-margin">
                <div class="col-md-1 ct-col jh-tit-sel">
                    <select class="form-control" ref="query_conditions">
                        <option value="kh_id">会员卡号</option>
                        <option value="phone_numb">会员手机号</option>
                        <option value="dh_id">充值单号</option>
                        <!-- <option value="get_memb">提成员工</option> -->
                    </select>
                </div>
                <div class="col-md-2 jh-con-val">
                    <input type="text" class="form-control" v-model="search_info" :placeholder="employeeinput">
                </div>
                <label class="list-label-4">充值员工:</label>
                <div class="col-md-2 ct-col">
                    <select class="form-control" ref="member_admin" data-placeholder="请选择充值员工"></select>
                </div>
                <label class="list-label-4">提成员工:</label>
                <div class="col-md-2 ct-col">
                    <select class="form-control" ref="member_commission" data-placeholder="请选择提成员工"></select>
                </div>
                <div class="col-md-2 ct-col only-today-register">
                    <input type="checkbox" v-model="only_today_register" /><label>仅当天注册会员充值</label>
                </div>
                <div>
                    <button type="button" class="btn btn-flat btn-small btn-orange" @click="getOrderList(1)"
                        style="margin-right: 10px">查询</button>
                    <button type="button" class="btn btn-flat btn-small btn-border-gray"
                        @click="getExportSet">导出</button>
                </div>
            </div>
            <div class="row row-margin">
                <label class="list-label-4">充值类型:</label>
                <div class="col-md-2 ct-col">
                    <select class="form-control" data-placeholder="请选择" ref="recharge_type">
                        <option value="0">全部</option>
                        <option value="1">线下充值</option>
                        <option value="2">自助充值</option>
                    </select>
                </div>
            </div>
            <div class="row">
                <label class="list-label-4">充值金额:</label>
                <div class="list-total" ref="cz_money"></div>
                <label class="list-label-4">赠送金额:</label>
                <div class="list-total" ref="zs_money"></div>
            </div>
            <el-table 
                v-loading="loading" 
                element-loading-text="努力加载中，请稍后..."
                element-loading-background="rgba(0, 0, 0, 0.6)" 
                :header-cell-style="{'text-align':'center'}"
                :cell-style="{'text-align':'center'}" 
                :data="list_table">
                <el-table-column label="行号" width="50">
                    <template slot-scope="scope">{{scope.$index + 1}}</template>
                </el-table-column>
                <el-table-column prop="create_time" label="充值时间" width="110"></el-table-column>
                <el-table-column prop="id" label="充值单号" width="130"></el-table-column>
                <el-table-column prop="recharge_shop_name" label="收款门店" width="110"></el-table-column>
                <el-table-column prop="vip_shop_name" label="注册门店" width="110"></el-table-column>
                <el-table-column prop="vip_card" label="会员卡号" width="150"></el-table-column>
                <el-table-column prop="username" label="会员姓名"></el-table-column>
                <el-table-column prop="vip_mobile" label="会员手机号" width="120"></el-table-column>
                <el-table-column prop="vip_register_time" label="会员注册时间" width="110"></el-table-column>
                <el-table-column prop="recharge_amount" label="充值金额"></el-table-column>
                <el-table-column prop="recharge_account_name" label="充值入账"></el-table-column>
                <el-table-column prop="present_amount" label="赠送金额"></el-table-column>
                <el-table-column prop="present_account_name" label="赠送入账"></el-table-column>
                <el-table-column prop="status" label="支付状态"></el-table-column>
                <el-table-column prop="pay_platform" label="支付类型" width="120"></el-table-column>
                <el-table-column prop="admin_name" label="充值员工"></el-table-column>
                <el-table-column prop="commission_admin_name" label="提成员工"></el-table-column>
                <el-table-column prop="before_account" label="充值前通用余额"></el-table-column>
                <el-table-column prop="before_present_account" label="充值前赠送余额"></el-table-column>
                <el-table-column prop="before_room_account" label="充值前房费余额"></el-table-column>
                <el-table-column prop="after_account" label="充值后通用余额"></el-table-column>
                <el-table-column prop="after_present_account" label="充值后赠送余额"></el-table-column>
                <el-table-column prop="after_room_account" label="充值后房费余额"></el-table-column>
                <el-table-column prop="recharge_type_name" label="充值类型"></el-table-column>
            </el-table>
            <el-pagination 
                background 
                layout="total, prev, pager, next, jumper" 
                :page-size="GLOBAL.PAGESIZE"
                :current-page.sync="list_page" 
                :total="list_total" 
                @current-change="getOrderList">
            </el-pagination>
            <!-- 导出设置弹窗 -->
            <div ref="czExport_alert" class="ele-hide">
                <div class="set-export sel-seldiv">
                    <h3>请选择导出报表需要的显示的字段</h3>
                    <ul class="set-area clearfix">
                        <li>
                            <input type='checkbox' v-model='czExport_allcheck' @click='czExportCheckedAll'>
                            <label>全选</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='czExport_checkModel' value="create_time">
                            <label>充值时间</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='czExport_checkModel' value="id">
                            <label>充值单号</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='czExport_checkModel' value="recharge_shop_name">
                            <label>收款门店</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='czExport_checkModel' value="vip_shop_name">
                            <label>注册门店</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='czExport_checkModel' value="vip_card">
                            <label>会员卡号</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='czExport_checkModel' value="username">
                            <label>会员姓名</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='czExport_checkModel' value="vip_mobile">
                            <label>会员手机号</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='czExport_checkModel' value="recharge_amount">
                            <label>充值金额</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='czExport_checkModel' value="recharge_account_name">
                            <label>充值入账</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='czExport_checkModel' value="present_amount">
                            <label>赠送金额</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='czExport_checkModel' value="present_account_name">
                            <label>赠送入账</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='czExport_checkModel' value="status">
                            <label>支付状态</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='czExport_checkModel' value="pay_platform">
                            <label>支付类型</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='czExport_checkModel' value="admin_name">
                            <label>充值员工</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='czExport_checkModel' value="commission_admin_name">
                            <label>提成员工</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='czExport_checkModel' value="before_account">
                            <label>充值前通用余额</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='czExport_checkModel' value="before_present_account">
                            <label>充值前赠送余额</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='czExport_checkModel' value="before_room_account">
                            <label>充值前房费余额</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='czExport_checkModel' value="after_account">
                            <label>充值后通用余额</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='czExport_checkModel' value="after_present_account">
                            <label>充值后赠送金额</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='czExport_checkModel' value="after_room_account">
                            <label>充值后房费余额</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='czExport_checkModel' value="recharge_type_name">
                            <label>充值类型</label>
                        </li>
                    </ul>
                    <h3>请选择导出报表的文件格式</h3>
                    <ul class="clearfix">
                        <li>
                            <input type="radio" v-model='czExport_type' value="1">
                            <label>excel表格</label>
                        </li>
                        <li>
                            <input type="radio" v-model='czExport_type' value="2">
                            <label>pdf文件</label>
                        </li>
                    </ul>
                </div>
            </div>
            <!-- 预约导出弹窗 -->
            <div class="book-export-pop ele-hide" ref="book_export_pop">
                <div class="red-tip">由于当前导出数据量较大，您需操作预约导出，操作预约导出后，需等待系统生成数据，数据生成完成后可在历史预约中下载查看！数据生成过程中可以关闭当前窗口，可再次操作“导出”进入查看导出进度。</div>
                <div class="pop-row center">
                    <el-button type="primary" @click="doBookExport">预约导出</el-button>
                    <el-button @click="cancelExport">取消</el-button>
                </div>
                <div class="row-tip">历史预约（注：历史预约仅显示该登录账号最近一次预约操作数据）</div>
                <div class="pop-row bottom" v-if="book_export_log_list.length>0">
                    <div class="time">{{book_export_log_list[0].create_time}}</div>
                    <div class="right">
                        <span class="status">{{book_export_log_list[0].status_name}}</span>
                        <el-button type="primary" :disabled="book_export_log_list[0].status==0" @click="downloadFile">下载</el-button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import Vue from 'vue';
    export default {
        name: '',
        data() {
            return {
                startTime: "",
                endTime: "",
                cz_field: '1',
                cz_init_shop: '',
                shopDatas: [],
                paytype: [],
                employeeinput: '请输入会员卡号',
                search_field: "kh_id",
                search_info: "",
                czExport_allcheck: false,
                c_czExport_allcheck: false,
                czExport_checkModel: [],
                czExport_checkData: ['create_time', 'id', 'recharge_shop_name', 'vip_shop_name', 'vip_card', 'username', 'vip_mobile', 'recharge_amount', 'recharge_account_name', 'present_amount', 'present_account_name', 'status', 'pay_platform', 'admin_name', 'commission_admin_name', 'before_account', 'before_present_account', 'before_room_account', 'after_account', 'after_present_account', 'after_room_account', 'recharge_type_name'],
                czExport_type: 1,
                only_today_register: false,

                loading: false,
                list_table: [],
                list_total: 0,
                list_page: 1,
                page_size: 10,
                book_export_log_list: [], // 预约导出记录
            }
        },
        watch: {
            czExport_checkModel: {
                handler: function (val, oldVal) {
                    if(this.czExport_checkModel.length >= this.czExport_checkData.length) {
                        this.czExport_allcheck = true;
                        this.c_czExport_allcheck = true;
                    } else {
                        this.czExport_allcheck = false;
                        this.c_czExport_allcheck = false;
                    }
                },
                deep: true
            },
        },
        mounted: function() {
            const _this = this
            // 日期
            _this.startTime = moment().hour(8).minute(0).format('YYYY-MM-DD HH:mm');
            _this.endTime = moment().add(1, 'day').hour(8).minute(0).format('YYYY-MM-DD HH:mm');
            _this.innitDate(); // 日期
            // 下拉选项
            $(_this.$refs.cz_tit_sel).select2({
                language: "zh-CN",
                minimumResultsForSearch: -1,
                width: '100%'
            }).change(function() {
                _this.cz_field = $(this).val();
                if(_this.cz_field == '1') {
                    $(_this.$refs.cz_shop).val(_this.cz_init_shop).trigger('change');
                    $(_this.$refs.cz_reg_shop).val('').trigger('change');
                } else {
                    $(_this.$refs.cz_shop).val('').trigger('change');
                    $(_this.$refs.cz_reg_shop).val(_this.cz_init_shop).trigger('change');
                }
                _this.getPaytype(_this.cz_init_shop);
            });
            // 支付状态
            $(_this.$refs.paymentstatus).select2({
                minimumResultsForSearch: -1,
                language: "zh-CN",
                width: '100%'
            });
            // 充值类型
            $(_this.$refs.recharge_type).select2({
                minimumResultsForSearch: -1,
                language: "zh-CN",
                width: '100%'
            });
            _this.shopDatas = [];
            _this.innitInput();  // 门店
            // 下拉选项
            $(_this.$refs.query_conditions).select2({
                language: "zh-CN",
                minimumResultsForSearch: -1
            }).change(function() {
                _this.search_field = $(this).val();
                if(_this.search_field == 'kh_id') {
                    _this.employeeinput = '请输入会员卡号';
                } else if(_this.search_field == 'phone_numb') {
                    _this.employeeinput = '请输入会员手机号';
                } else if(_this.search_field == 'dh_id') {
                    _this.employeeinput = '请输入充值单号';
                } else if(_this.search_field == 'get_memb') {
                    _this.employeeinput = '请输入提成员工';
                }
            });
            // 充值员工
            _this.getAdmin('');
        },
        methods: {
            setShopDefaultTime(shop_id) {
                let report_default_time = '1'
                let shop_report_default_time = this.$store.state.shop_report_default_time
                shop_report_default_time.forEach(item => {
                    if (shop_id == item.shop_id) {
                        report_default_time = item.report_default_time
                        if (report_default_time == '1') {
                            this.startTime = moment().hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                            this.endTime = moment().add(1, 'day').hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                        }else {
                            this.startTime = moment().subtract(1, 'day').hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                            this.endTime = moment().hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                        }
                    }
                })
            },
            // 初始化日期插件
            innitDate: function() {
                const _this = this;
                $(_this.$refs.time).daterangepicker({
                    timePicker: true,
                    timePickerIncrement: 1,
                    timePicker12Hour: false,
                    buttonClasses: ['btn btn-default'],
                    applyClass: 'btn-small btn-orange',
                    cancelClass: 'btn-small btn-gray',
                    startDate: moment().hour(8).minute(0).toDate(),
                    endDate: moment().add(1, 'day').hour(8).minute(0).toDate(),
                }, function(start, end, label) {
                    _this.startTime = start.format('YYYY-MM-DD HH:mm');
                    _this.endTime = end.format('YYYY-MM-DD HH:mm');
                });
            },
            // 初始化门店输入框
            innitInput: function() {
                let _this = this;

                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "page": "1",
                            "page_size": "0",
                            "name": "",
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "PublicData/api_getShopListByPurview",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            $.each(data.response.result, function(k, v) {
                                _this.shopDatas.push({
                                    id: v.id,
                                    text: v.name
                                });
                            });
                            $(_this.$refs.cz_shop).select2({
                                data: _this.shopDatas,
                                language: "zh-CN",
                                width: '100%'
                            }).on("select2:select", function(e) {
                                _this.getPaytype(e.params.data.id);
                                _this.setShopDefaultTime(e.params.data.id)
                            });
                            $(_this.$refs.cz_reg_shop).select2({
                                data: _this.shopDatas,
                                language: "zh-CN",
                                width: '100%'
                            }).on("select2:select", function(e) {
                                _this.getPaytype(e.params.data.id);
                            });
                            _this.cz_init_shop = data.response.result[1].id;
                            _this.setShopDefaultTime(data.response.result[1].id)
                            $(_this.$refs.cz_shop).val(_this.cz_init_shop).trigger('change');
                            // 获取支付类型
                            _this.getPaytype(_this.cz_init_shop);
                            _this.getOrderList(1);
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },
            // 获取支付类型
            getPaytype: function(shop_id) {
                let _this = this;
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "shop_id": shop_id
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "Order/getAllPayPlatform",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            _this.paytype = [{id: ' ', text: '全部'}];
                            let value = data.response.data;
                            for(var key in value) {
                                _this.paytype.push({id: key, text: value[key]});
                            }
                            $(_this.$refs.paymenttype).html('');
                            $(_this.$refs.paymenttype).select2({
                                data: _this.paytype,
                                allowClear: true,
                                minimumResultsForSearch: -1
                            });
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },
            // 获取操作人数据
            getAdmin: function(shop_id) {
                let _this = this;
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "shop_id": shop_id
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "User/getList",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            let arr = [{ id: " ", text: "全部" }];
                            $.each(data['response']['result']['user_info'], function(k, v) {
                                arr.push({ id: v.id, text: v.name });
                            });
                            $(_this.$refs.member_admin).html("");
                            $(_this.$refs.member_admin).select2({
                                data: arr,
                                language: "zh-CN",
                                width: '100%'
                            });
                            $(_this.$refs.member_commission).html("");
                            $(_this.$refs.member_commission).select2({
                                data: arr,
                                language: "zh-CN",
                                width: '100%'
                            });
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },

            // 获取会员充值报表列表
            getOrderList: function(page) {
                this.list_page = page
                this.loading = true
                let _this = this,
                    status = $(_this.$refs.paymentstatus).val(),
                    admin_id = $.trim($(_this.$refs.member_admin).val()),
                    commission_admin_id = $.trim($(_this.$refs.member_commission).val()),
                    only_today_register = _this.only_today_register?'1':'';
                let vip_card = '',
                    vip_mobile = '',
                    id = '',
                    commission_admin_name = '';
                if(_this.search_field == 'kh_id') {
                    vip_card = _this.search_info;
                } else if(_this.search_field == 'phone_numb') {
                    vip_mobile = _this.search_info;
                } else if(_this.search_field == 'dh_id') {
                    id = _this.search_info;
                } else if(_this.search_field == 'get_memb') {
                    commission_admin_name = _this.search_info;
                }
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "page": page,
                            "page_size": _this.page_size,
                            "start_time": _this.startTime,
                            "end_time": _this.endTime,
                            "shop_id": $(_this.$refs.cz_shop).val(),
                            "vip_shop_id": $(_this.$refs.cz_reg_shop).val(),
                            "status": status == '100' ? "" : status,
                            "admin_id": admin_id,
                            "commission_admin_id": commission_admin_id,
                            "pay_platform": $.trim($(_this.$refs.paymenttype).val()),
                            "vip_card": vip_card,
                            "vip_mobile": vip_mobile,
                            "id": id,
                            "commission_admin_name": commission_admin_name,
                            "only_today_register": only_today_register,
                            "recharge_type": $.trim($(_this.$refs.recharge_type).val())
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "FinanceReport/getVipRechargeList",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        _this.loading = false
                        if(data.response.result_code == "true") {
                            _this.list_table = data.response.result.rows
                            _this.list_total = Number(data.response.result.total)
                            $(_this.$refs.cz_money).text(data.response.result.recharge_amount_total);
                            $(_this.$refs.zs_money).text(data.response.result.present_amount_total);
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        _this.loading = false
                        layer.msg("出错啦");
                    }
                });
            },
            // 获取导出设置
            getExportSet: function() {
                let _this = this;
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "report_type": "FinanceReport/vipRechargeExport"
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "FinanceReport/getExportSet",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            if(data.response.result) {
                                _this.czExport_checkModel = data.response.result.export_fields;
                                _this.czExport_type = data.response.result.export_type;
                            } else {
                                _this.czExport_checkModel = _this.czExport_checkData;
                                _this.czExport_type = 1;
                            }
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });

                // 弹窗
                layer.confirm('', {
                    skin: 'add_printer_area',
                    type: 1,
                    btn: ['确定', '取消'], // 按钮
                    title: ['导出设置', true],
                    area: ['830px', ''], // 宽高
                    content: $(_this.$refs.czExport_alert)
                }, function() {
                    _this.checkExport();
                });
            },
            // 导出字段全选
            czExportCheckedAll: function() {
                let _this = this;
                _this.czExport_allcheck = _this.c_czExport_allcheck;
                if(!_this.czExport_allcheck) { // 实现全选
                    _this.czExport_checkModel = [];
                    _this.czExport_checkData.forEach(function(item) {
                        _this.czExport_checkModel.push(item);
                    });
                } else { // 实现反选
                    _this.czExport_checkModel = [];
                }
            },

            // 检查导出状态
            checkExport() {
                let _this = this,
                    status = $(_this.$refs.paymentstatus).val(),
                    admin_id = $.trim($(_this.$refs.member_admin).val()),
                    commission_admin_id = $.trim($(_this.$refs.member_commission).val()),
                    only_today_register = _this.only_today_register?'1':'';
                let vip_card = '',
                    vip_mobile = '',
                    id = '',
                    commission_admin_name = '';
                if(_this.search_field == 'kh_id') {
                    vip_card = _this.search_info;
                } else if(_this.search_field == 'phone_numb') {
                    vip_mobile = _this.search_info;
                } else if(_this.search_field == 'dh_id') {
                    id = _this.search_info;
                } else if(_this.search_field == 'get_memb') {
                    commission_admin_name = _this.search_info;
                }
                Vue.axios.post('exportBook/exportCheck', {
                    "header": Vue.request_header,
                    "request": {
                        "type": 'vipRecharge',
                        "param": {
                            "page": _this.list_page,
                            "page_size": _this.page_size,
                            "start_time": _this.startTime,
                            "end_time": _this.endTime,
                            "shop_id": $(_this.$refs.cz_shop).val(),
                            "vip_shop_id": $(_this.$refs.cz_reg_shop).val(),
                            "status": status == '100' ? "" : status,
                            "admin_id": admin_id,
                            "commission_admin_id": commission_admin_id,
                            "pay_platform": $.trim($(_this.$refs.paymenttype).val()),
                            "vip_card": vip_card,
                            "vip_mobile": vip_mobile,
                            "id": id,
                            "commission_admin_name": commission_admin_name,
                            "only_today_register": only_today_register,
                            "recharge_type": $.trim($(_this.$refs.recharge_type).val()),
                        }
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        layer.closeAll()
                        if (res.data.response.result.status == '1') { // 原逻辑直接导出
                            _this.exportList();
                        }else {
                            _this.book_export_log_list = res.data.response.result.log_list
                            // 预约导出弹窗
                            layer.confirm('', {
                                skin: 'public-alert-skin',
                                type: 1,
                                btn: [], // 按钮
                                title: ['导出提示', true],
                                area: ['700px', ''], // 宽高
                                content: $(_this.$refs.book_export_pop),
                                offset: '100px',
                            });
                        }

                    } else {
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg("出错啦");
                });
            },
            
            // 预约导出
            doBookExport() {
                let _this = this,
                    status = $(_this.$refs.paymentstatus).val(),
                    admin_id = $.trim($(_this.$refs.member_admin).val()),
                    commission_admin_id = $.trim($(_this.$refs.member_commission).val()),
                    only_today_register = _this.only_today_register ? '1' : '';
                status = status == '100' ? "" : status;
                let export_fields = JSON.stringify(_this.czExport_checkModel);
                let vip_card = '',
                    vip_mobile = '',
                    id = '',
                    commission_admin_name = '';
                if (_this.search_field == 'kh_id') {
                    vip_card = _this.search_info;
                } else if (_this.search_field == 'phone_numb') {
                    vip_mobile = _this.search_info;
                } else if (_this.search_field == 'dh_id') {
                    id = _this.search_info;
                } else if (_this.search_field == 'get_memb') {
                    commission_admin_name = _this.search_info;
                }

                Vue.axios.post('exportBook/addExportBook', {
                    "header": Vue.request_header,
                    "request": {
                        "type": 'vipRecharge',
                        "param": {
                            "page": _this.list_page,
                            "page_size": _this.page_size,
                            "start_time": _this.startTime,
                            "end_time": _this.endTime,
                            "shop_id": $(_this.$refs.cz_shop).val(),
                            "vip_shop_id": $(_this.$refs.cz_reg_shop).val(),
                            "status": status == '100' ? "" : status,
                            "admin_id": admin_id,
                            "commission_admin_id": commission_admin_id,
                            "pay_platform": $.trim($(_this.$refs.paymenttype).val()),
                            "vip_card": vip_card,
                            "vip_mobile": vip_mobile,
                            "id": id,
                            "commission_admin_name": commission_admin_name,
                            "only_today_register": only_today_register,
                            "recharge_type": $.trim($(_this.$refs.recharge_type).val()),
                            "export_fields": export_fields,
                        }
                    },
                    "comment": ""
                })
                    .then(res => {
                        if (res.data.response.result_code == "true") {
                            _this.book_export_log_list = res.data.response.result.log_list
                        } else {
                            layer.msg(res.data.response.error_msg);
                        }
                    })
                    .catch(err => {
                        layer.msg("出错啦");
                    });
            },

            // 下载文件
            downloadFile() {
                // 已知文件的URL
                const fileUrl = this.book_export_log_list[0].file_url
                const fileName = "file.pdf"; // 自定义文件名

                // 创建一个隐藏的 <a> 元素
                const a = document.createElement("a");
                a.href = fileUrl;
                a.download = fileName;

                // 将 <a> 元素添加到页面中
                document.body.appendChild(a);

                // 触发点击事件，下载文件
                a.click();

                // 下载完成后移除该 <a> 元素
                document.body.removeChild(a);
            },

            cancelExport() {
                layer.closeAll()
            },


            // 确定“导出”
            exportList: function() {
                let _this = this,
                    status = $(_this.$refs.paymentstatus).val(),
                    admin_id = $.trim($(_this.$refs.member_admin).val()),
                    commission_admin_id = $.trim($(_this.$refs.member_commission).val()),
                    only_today_register = _this.only_today_register ? '1' : '';
                    status = status == '100' ? "" : status;
                let export_fields = JSON.stringify(_this.czExport_checkModel);
                let vip_card = '',
                    vip_mobile = '',
                    id = '',
                    commission_admin_name = '';
                if(_this.search_field == 'kh_id') {
                    vip_card = _this.search_info;
                } else if(_this.search_field == 'phone_numb') {
                    vip_mobile = _this.search_info;
                } else if(_this.search_field == 'dh_id') {
                    id = _this.search_info;
                } else if(_this.search_field == 'get_memb') {
                    commission_admin_name = _this.search_info;
                }
                window.location.href = Vue.ctUrl + "FinanceReport/vipRechargeExport?" +
                    "&start_time=" + _this.startTime +
                    "&end_time=" + _this.endTime +
                    "&shop_id=" + $(_this.$refs.cz_shop).val() +
                    "&vip_shop_id=" + $(_this.$refs.cz_reg_shop).val() +
                    "&status=" + status +
                    "&admin_id=" + admin_id +
                    "&commission_admin_id=" + commission_admin_id +
                    "&pay_platform=" + $.trim($(_this.$refs.paymenttype).val()) +
                    "&vip_card=" + vip_card +
                    "&vip_mobile=" + vip_mobile +
                    "&id=" + id +
                    "&commission_admin_name=" + commission_admin_name +
                    "&only_today_register=" + only_today_register +
                    "&recharge_type=" + $.trim($(_this.$refs.recharge_type).val()) +
                    "&export_fields=" + export_fields +
                    "&export_type=" + _this.czExport_type;
                // debugger;
                layer.msg("导出成功！");
                layer.closeAll();
            },
        }
    }
</script>
<style lang="less" scoped>
    .member-cz-list {
        .only-today-register {
            line-height: 32px;
            input {
                margin-right: 5px;
            }
        }
    }
    // 预约导出
    .book-export-pop {
        position: relative;
        .red-tip {
            color: red;
        }
        .pop-row {
            display: flex;
            flex-direction: row;
            align-items: center;
            &.center {
                margin: 30px 0 60px 0;
                justify-content: center;
            }
            &.bottom {
                position: absolute;
                left: 0;
                bottom: 0;
                width: 100%;
                padding: 0 35px;
                box-sizing: border-box;
                justify-content: space-between;
                .right {
                    .status {
                        margin-right: 10px;
                        color: #409EFF;
                    }
                }
            }
        }
        .row-tip {
            margin-bottom: 20px;
        }
        .el-button {
            width: 100px;
        }
    }
</style>